export function getEnv(name, defaultValue) {
  return window._env_?.[name] ?? defaultValue;
}

export function getEnvBool(name, defaultValue = false) {
  const envVar = getEnv(name, defaultValue);
  return envVar === true || String(envVar).toLowerCase() === 'true';
}
